if (!customElements.get("delivery-estimation")) {
	customElements.define(
		"delivery-estimation",
		class DeliveryEstimation extends HTMLElement {
			constructor() {
				super();

				this.steps = this.querySelectorAll(".delivery-step");
				if (this.steps && this.steps.length > 0) {
					this.steps.forEach((step) => this.showDate(step));
				}
			}

			showDate(step) {
				const daysToAdd = +step.dataset.days;
				if (daysToAdd || daysToAdd === 0) {
					const text = step.querySelector(".delivery-date");
					const format = this.dataset.format;
					const newDate = this.formatDate(this.addDays(daysToAdd), format);
					text.textContent = newDate;
				} else {
					return;
				}
			}

			addDays(days) {
				const result = new Date();
				result.setDate(result.getDate() + days);
				return result;
			}

			formatDate(date, format) {
				const pad = (n) => String(n).padStart(2, "0");
				const map = {
					DD: pad(date.getDate()),
					MM: pad(date.getMonth() + 1),
					YYYY: date.getFullYear(),
				};
				return format.replace(/DD|MM|YYYY/g, (token) => map[token]);
			}
		}
	);
}
